export const heroData = {
  brandName: "在线吃瓜官网",
  tagline: "直击网红塌房现场",
  subtitle: "每日黑料实时追踪 · 免费在线吃瓜",
  ctaText: "🔥 今日吃瓜入口",
};

export const hotGossipItems = [
  {
    id: 1,
    title: "千万粉博主李某人设崩塌",
    description: "私下辱骂粉丝录音曝光，品牌代言一夜全撤",
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20dramatic%20photography%20of%20a%20shattered%20social%20media%20influencer%20set%2C%20broken%20smartphone%20screen%20with%20crack%20patterns%2C%20red%20and%20black%20cinematic%20lighting%2C%20moody%20atmosphere%2C%20editorial%20photography%20style%2C%20dark%20background%20with%20subtle%20glow%2C%20professional%20color%20grade%2C%20dramatic%20shadows%2C%20high%20contrast&width=800&height=500&seq=hot-gossip-01&orientation=landscape",
    featured: true,
    articleId: "article-001",
  },
  {
    id: 2,
    title: "某顶流带货主播涉嫌虚假宣传",
    description: "质检报告造假，直播间被封禁72小时",
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20moody%20product%20photography%20of%20skincare%20products%20on%20a%20black%20surface%2C%20fake%20certification%20documents%20partially%20visible%2C%20red%20warning%20light%20in%20background%2C%20cinematic%20noir%20lighting%2C%20dramatic%20shadows%2C%20editorial%20style%2C%20dark%20atmosphere%2C%20subtle%20crimson%20accents%2C%20professional%20photography&width=800&height=1067&seq=hot-gossip-02&orientation=landscape",
    featured: false,
    articleId: "article-002",
  },
  {
    id: 3,
    title: "情侣博主分手实为剧本炒作",
    description: "前员工爆料：所有甜蜜视频均为团队策划",
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20scene%20of%20a%20broken%20heart%20prop%20on%20a%20film%20set%2C%20movie%20script%20papers%20scattered%2C%20dramatic%20red%20and%20black%20lighting%2C%20film%20camera%20in%20background%2C%20moody%20atmosphere%2C%20editorial%20photography%2C%20dark%20background%2C%20professional%20color%20grade%2C%20high%20contrast%20shadows&width=800&height=1067&seq=hot-gossip-03&orientation=landscape",
    featured: false,
    articleId: "article-003",
  },
  {
    id: 4,
    title: "知名美妆博主整容前后对比曝光",
    description: "素人时期照片流出，粉丝直呼认不出",
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20mysterious%20beauty%20photography%2C%20half%20face%20in%20shadow%20half%20illuminated%20by%20warm%20light%2C%20makeup%20brushes%20and%20cosmetics%20scattered%20on%20black%20marble%2C%20cinematic%20lighting%2C%20dramatic%20contrast%2C%20editorial%20fashion%20photography%2C%20moody%20atmosphere%2C%20dark%20background%2C%20crimson%20color%20grade&width=800&height=1067&seq=hot-gossip-04&orientation=landscape",
    featured: false,
    articleId: "article-001",
  },
  {
    id: 5,
    title: "电竞圈又出大瓜：冠军选手被爆假赛",
    description: "内部聊天记录曝光，涉及金额超千万",
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20dramatic%20esports%20gaming%20setup%20scene%2C%20gaming%20keyboard%20with%20red%20backlight%2C%20shattered%20trophy%20on%20black%20desk%2C%20moody%20cinematic%20lighting%2C%20professional%20photography%2C%20dark%20atmosphere%2C%20dramatic%20shadows%2C%20red%20and%20black%20color%20scheme%2C%20editorial%20style&width=800&height=1067&seq=hot-gossip-05&orientation=landscape",
    featured: false,
    articleId: "article-004",
  },
  {
    id: 6,
    title: "某知名大V涉嫌学历造假",
    description: "自称海外名校博士，实际未完成高中学业",
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20photography%20of%20a%20fake%20diploma%20certificate%20with%20official%20stamps%2C%20university%20building%20silhouette%20in%20background%2C%20dramatic%20red%20and%20black%20lighting%2C%20moody%20noir%20atmosphere%2C%20editorial%20style%2C%20professional%20photography%2C%20dark%20shadows%2C%20subtle%20crimson%20glow&width=800&height=1067&seq=hot-gossip-06&orientation=landscape",
    featured: false,
    articleId: "article-006",
  },
];

export const todayContentItems = [
  {
    id: 1,
    title: "【独家】某选秀冠军私生活混乱，多人实锤",
    summary: "近日，有知情人士向本站独家爆料，某知名选秀节目冠军得主私生活极为混乱。据多位不愿透露姓名的圈内人士证实，该艺人利用明星身份...",
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20dramatic%20entertainment%20scene%2C%20talent%20show%20stage%20with%20spotlight%20turned%20off%2C%20empty%20audience%20seats%2C%20broken%20trophy%2C%20cinematic%20moody%20lighting%2C%20red%20and%20black%20atmosphere%2C%20editorial%20photography%2C%20dark%20shadows%2C%20professional%20color%20grade&width=800&height=500&seq=today-content-01&orientation=landscape",
    featured: true,
    articleId: "article-001",
  },
  {
    id: 2,
    title: "网红王小美",
    tag: "HOT",
    description: "被前男友曝光出轨实锤，聊天记录尺度惊人",
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20portrait%20photography%20of%20a%20young%20woman%20silhouette%20in%20dramatic%20red%20lighting%2C%20smartphone%20screen%20glow%20on%20face%2C%20moody%20cinematic%20atmosphere%2C%20editorial%20style%2C%20dark%20background%20with%20subtle%20gradient%2C%20professional%20photography%2C%20noir%20inspired&width=600&height=450&seq=today-content-02&orientation=landscape",
    featured: false,
    articleId: "article-003",
  },
  {
    id: 3,
    title: "美食博主赵大胃",
    tag: "NEW",
    description: "假吃视频被扒，后期剪辑手法全解析",
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20moody%20food%20photography%2C%20elegant%20dishes%20on%20black%20table%20setting%2C%20one%20plate%20shattered%2C%20dramatic%20red%20and%20black%20lighting%2C%20cinematic%20atmosphere%2C%20editorial%20style%2C%20dark%20background%2C%20professional%20photography%2C%20subtle%20crimson%20accents&width=600&height=450&seq=today-content-03&orientation=landscape",
    featured: false,
    articleId: "article-002",
  },
  {
    id: 4,
    title: "健身达人陈教练",
    tag: "HOT",
    description: "卖假补剂被粉丝集体起诉，涉及金额超三百万",
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20dramatic%20fitness%20scene%2C%20dumbbells%20and%20supplement%20bottles%20on%20black%20floor%2C%20some%20bottles%20broken%2C%20red%20warning%20light%2C%20cinematic%20noir%20lighting%2C%20moody%20atmosphere%2C%20editorial%20photography%2C%20dark%20background%2C%20professional%20color%20grade&width=600&height=450&seq=today-content-04&orientation=landscape",
    featured: false,
    articleId: "article-005",
  },
];

export const ctaData = {
  title: "每天都有新爆料，第一时间掌握网红塌房信息！",
  subtitle: "关注我们，不错过任何一个大瓜",
  buttonText: "📬 订阅每日黑料推送",
  imageUrl: "https://readdy.ai/api/search-image?query=Dark%20artistic%20abstract%20photography%2C%20dramatic%20red%20and%20black%20waves%20and%20textures%2C%20mysterious%20glowing%20particles%2C%20cinematic%20color%20grade%2C%20professional%20fine%20art%20photography%2C%20dark%20moody%20atmosphere%2C%20abstract%20shapes%2C%20elegant%20composition%2C%20noir%20inspired%2C%20subtle%20crimson%20and%20deep%20black%20gradients&width=1200&height=600&seq=cta-section&orientation=landscape",
};

export const navLinks = [
  { name: "首页", path: "/" },
  { name: "网红塌房", path: "/category/wanghong-tafang" },
  { name: "黑料爆料", path: "/category/heiliao-baoliao" },
  { name: "吃瓜视频", path: "/category/chigua-video" },
  { name: "关于我们", path: "/about" },
];